<template>
  <div id="blade3">
    <GroupContainer :obj="stObj.gC">
      <template slot="slot1">
        <TwelveCol>
          <template slot="slot1">
            <h2 class="blade-3-headline" slot="slot1" v-html="stObj.title" data-aos="fade-left"></h2>

            <div class="col no-padding col-md-6" slot="slot1">
              <p
                class="body blade-3-p"
                slot="slot1"
                v-for="(p, index) in stObj.paragraphs"
                v-html="p"
                :key="`blade3-p-${index}`"
                data-aos="fade-up"
                data-aos-delay="500"
              ></p>
            </div>
            <div slot="slot2" class="div2 col-md-6">
              <video
                autoplay
                muted
                loop
                playsinline
                data-aos="fade-up"
                data-aos-delay="1000"
                id="blade3video"
                :aria-label="stObj.backgroundVideoAltText"
              >
                <source :src="stObj.backgroundVideo" type="video/mp4" />
              </video>
            </div>
          </template>
        </TwelveCol>
      </template>
    </GroupContainer>
  </div>
</template>

<script>
import GroupContainer from "../../2019-immersive-modular-experience/src/components/GroupContainer";
import TwelveCol from "../../2019-immersive-modular-experience/src/components/TwelveCol";
import { inView } from "../helpers/inView";

export default {
  name: "Blade3",
  data: function() {
    return {
      sPW: 0,
      hasAnimated: false
    };
  },
  components: {
    GroupContainer,
    TwelveCol
  },
  computed: {
    stObj() {
      return this.$store.state.blade3;
    }
  },
  methods: {
    checkInView() {
      if (!this.hasAnimated) {
        this.hasAnimated = inView("#blade3video", this.playVideo, "all");
      } else {
        document.removeEventListener("scroll", this.checkInView);
      }
    },
    playVideo() {
      document.getElementById("blade3video").play();
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener("scroll", this.checkInView);
    });
  },
  destroyed() {
    document.removeEventListener("scroll", this.checkInView);
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/blade3.scss";
</style>